import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import BwvcardDetails from "./BwvCardDetails";
import { Row, Col } from "reactstrap";
import {
  fetchBWV,
  BlockCalander,
  fetchOptionsList,
  fetchOptions,
  fetchMyServices,
} from "../Data";
import BwvCoupons from "./BwvCoupons";
import { useDispatch, useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";
import {
  setSelectedService,
  setViewCount,
  setViewers,
} from "../../../redux/slices/BwvData";
import { useSocket } from "../../../contexts/SocketContext";
import Recommended from "../LocalCummunityAds/Recommended";
import { logCustomerServiceView } from "../Data3";

const VendorDetails = () => {
  const dispatch = useDispatch();
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [bwv, setBwv] = useState([]);
  const { Id: cardId } = useParams();
  const { socket } = useSocket();
  const [recomended, setRecomended] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const gottonFetched = useRef(false);
  // const [viewers, setViewers] = useState(0);

  useEffect(() => {
    socket.emit("joinVendor", cardId);

    socket.on("updateViewers", (data) => {
      dispatch(setViewers(data[cardId] || 0));
      // setViewers(data[cardId] || 0);
    });

    socket.on("updateViewCounts", (data) => {
      dispatch(setViewCount(data[cardId] || 0));
      // setViewCount(data[cardId] || 0);
    });

    return () => {
      socket.emit("leaveVendor", cardId);
    };
  }, [cardId, socket]);

  const selectedCard = bwv.find((card) => card.Id === parseInt(cardId));

  let videos = {};
  try {
    if (selectedCard?.Video) {
      videos =
        typeof selectedCard?.Video === "string"
          ? JSON.parse(selectedCard?.Video)
          : selectedCard?.Video;
    }
  } catch (error) {
    console.error("Failed to parse videos:", error);
  }
  const fetchData = async () => {
    const bwvData = await fetchBWV();
    const filterBwvData = bwvData.filter((vendor) => vendor.isactive === "3");
    setBwv(filterBwvData);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  const zipCache = {};

  const fetchNearbyZips = async (zipcode) => {
    if (zipCache[zipcode]) {
      console.log("ZIP cache hit:", zipCache);
      return zipCache[zipcode];
    }

    try {
      const apiKey = process.env.REACT_APP_ZIPCODEBASE_KEY;
      const country = "US"; // Adjust as needed
      const radius = 20; // miles
      const unit = "mi"; // <-- Use miles instead of kilometers

      const response = await fetch(
        `https://app.zipcodebase.com/api/v1/radius?apikey=${apiKey}&code=${zipcode}&radius=${radius}&country=${country}&unit=${unit}`
      );
      const data = await response.json();

      if (data.results && Array.isArray(data.results)) {
        const resultZips = data.results.map((entry) => entry.code);
        zipCache[zipcode] = resultZips;
        console.log("ZIP cache updated:", zipCache); // ✅ correct timing
        return resultZips;
      } else {
        console.log(`No nearby ZIP codes found for ${zipcode}`);
        return [];
      }
    } catch (error) {
      console.error("Error fetching nearby ZIP codes:", error);
      return [];
    }
  };
  const fetchSimilarServices = async () => {
    const nearbyZips = await fetchNearbyZips(selectedCard?.Zipcode);
    console.log(nearbyZips, "nearbyZips");
    setIsLoading(true);
    const filterAds = bwv.filter(
      (ad) =>
        ad.categoryId === selectedCard.categoryId &&
        ad.subCategoryId === selectedCard.subCategoryId &&
        nearbyZips.includes(ad.Zipcode) &&
        ad.Id !== selectedCard.Id
    );
    setRecomended(filterAds);
    setIsLoading(false);
  };

  const logCustomerView = async () => {
    gottonFetched.current = true;
    let formData = {
      customerId: user?.UserID,
      serviceId: selectedCard?.Id,
    };
    await logCustomerServiceView(formData);
    console.log("Logged View");
  };

  useEffect(() => {
    if (selectedCard) {
      window.scrollTo(0, 0);
      dispatch(setSelectedService(selectedCard));
      selectedCard?.similarLocalVendor === 1 && fetchSimilarServices();
      selectedCard?.createdBy !== user?.UserID &&
        !gottonFetched.current &&
        logCustomerView();
    }
  }, [selectedCard, cardId]);
  console.log(recomended, "recomended");

  return (
    <div className={`${selectedCard ? "bg-white" : ""}`}>
      <div className="container ">
        {selectedCard ? (
          <>
            {" "}
            <BwvCoupons />
            <BwvcardDetails />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "50px 0px",
              height: "80vh",
            }}
          >
            <FadeLoader color="#36d7b7" />
          </div>
        )}
        {selectedCard?.similarLocalVendor === 1 && (
          <div>
            <h5>Similar Vendors</h5>
            {!isLoading ? (
              <Recommended recomended={recomended} type="listings" />
            ) : (
              <p
                className={`${isLoading ? "m-0 p-0" : ""} text-center fw-bold`}
              >
                Loading...
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorDetails;
